import React from 'react';
import { createPortal } from 'react-dom';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
} from '@mui/material';

interface LinkPopupProps {
  isOpen: boolean;
  linkData: { label: string; url: string };
  onLabelChange: (label: string) => void;
  onUrlChange: (url: string) => void;
  onCancel: () => void;
  onInsert: () => void;
}

export const LinkPopup: React.FC<LinkPopupProps> = ({
  isOpen,
  linkData,
  onLabelChange,
  onUrlChange,
  onCancel,
  onInsert,
}) => {
  if (!isOpen) return null;

  const popupContent = (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onCancel}
    >
      <Paper
        sx={{
          p: 3,
          minWidth: 400,
          maxWidth: 500,
          mx: 2,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography variant="h6" gutterBottom>
          Insérer un lien
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
          <TextField
            label="Texte du lien"
            value={linkData.label}
            onChange={(e) => onLabelChange(e.target.value)}
            placeholder="Texte à afficher"
            fullWidth
          />
          
          <TextField
            label="URL"
            value={linkData.url}
            onChange={(e) => onUrlChange(e.target.value)}
            placeholder="https://example.com"
            fullWidth
          />
        </Box>
        
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
          <Button 
            onClick={onCancel} 
            variant="outlined"
            size="small"
            sx={{ 
              border: '1px solid rgba(0, 0, 0, 0.23)',
              borderRadius: '4px',
              textTransform: 'none',
              '&:hover': {
                border: '1px solid rgba(0, 0, 0, 0.87)',
              }
            }}
          >
            Annuler
          </Button>
          <Button 
            onClick={onInsert} 
            variant="contained"
            disabled={!linkData.url.trim()}
            sx={{ 
              borderRadius: '4px',
              textTransform: 'none',
            }}
          >
            Insérer
          </Button>
        </Box>
      </Paper>
    </Box>
  );

  // Utiliser un portail pour sortir complètement du DOM de l'éditeur
  return createPortal(popupContent, document.body);
};
